export default __webpack_public_path__ + "static/media/filter-white.a9434ce4.svg";